import { faqData } from '@/mocks/home';

export default function SectionFAQ() {
  return (
    <section
      id="faq"
      className="py-16 md:py-20 bg-background-50"
    >
      <div className="max-w-[1920px] mx-auto px-4 md:px-6 lg:px-10">
        <div className="text-center mb-8 md:mb-10">
          <span className="inline-block text-xs font-medium text-secondary-400 bg-secondary-500/10 px-3 py-1 rounded-full mb-3">
            答疑解惑
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-50">
            常见问题
          </h2>
          <p className="text-sm text-foreground-400 mt-2">关于90影院，你可能想了解的</p>
        </div>

        <div className="max-w-3xl mx-auto space-y-3">
          {faqData.map((faq) => (
            <details
              key={faq.question}
              className="group bg-background-100 rounded-xl border border-background-300/40 overflow-hidden cursor-pointer"
            >
              <summary className="flex items-center justify-between p-5 md:p-6 text-sm md:text-base font-medium text-foreground-100 list-none">
                <span className="pr-4">{faq.question}</span>
                <div className="w-6 h-6 shrink-0 rounded-full bg-background-300/60 flex items-center justify-center group-open:rotate-45 transition-transform duration-200">
                  <i className="ri-add-line text-foreground-400 text-xs"></i>
                </div>
              </summary>
              <div className="px-5 md:px-6 pb-5 md:pb-6">
                <p className="text-sm text-foreground-400 leading-relaxed">{faq.answer}</p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}